var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTotalDevices(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 52,
    fill: "#ACACAC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_86_56220)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1050,
    transform: "translate(-43 -98)",
    fill: "#F4F7FA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.0771484,
    width: 52.4507,
    height: 51.8678,
    rx: 25.9339,
    fill: "#EBEFF2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.0771,
    y: 16,
    width: 15,
    height: 22,
    rx: 2,
    fill: "#C2D6DF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.0771,
    y: 20,
    width: 15,
    height: 22,
    rx: 2,
    fill: "#9BBCCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1224 8.00508C31.5477 7.94542 31.0781 8.41955 31.0781 8.99893C31.0781 9.57671 31.5492 10.0383 32.1224 10.1136C35.6807 10.58 38.4993 13.3966 38.9656 16.9557C39.041 17.5288 39.5027 17.9998 40.0805 17.9998C40.6584 17.9998 41.1326 17.5303 41.073 16.9541C40.5862 12.2407 36.8379 8.4931 32.1221 8.00476L32.1224 8.00508Z",
    fill: "#9BBCCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1021 18.0002C36.68 18.0002 37.1573 17.5276 37.0584 16.9577C36.6235 14.4409 34.637 12.4549 32.1182 12.0184C31.5482 11.9195 31.0771 12.3983 31.0771 12.9761C31.0771 13.5539 31.553 14.0092 32.112 14.1583C33.4766 14.5257 34.5522 15.6012 34.9181 16.9656C35.0689 17.5229 35.5227 18.0002 36.1021 18.0002H36.1021Z",
    fill: "#9BBCCB"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_86_56220)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -12,
    y: -18,
    width: 1521,
    height: 91,
    rx: 9.94788,
    fill: "#FEFEFF"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0.0771484,
    width: 52.4507,
    height: 51.8678,
    rx: 25.9339,
    fill: "#EBEFF2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.0771,
    y: 16,
    width: 15,
    height: 22,
    rx: 2,
    fill: "#979797"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.0771,
    y: 20,
    width: 15,
    height: 22,
    rx: 2,
    fill: "#767881"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1224 8.00508C31.5477 7.94542 31.0781 8.41955 31.0781 8.99893C31.0781 9.57671 31.5492 10.0383 32.1224 10.1136C35.6807 10.58 38.4993 13.3966 38.9656 16.9557C39.041 17.5288 39.5027 17.9998 40.0805 17.9998C40.6584 17.9998 41.1326 17.5303 41.073 16.9541C40.5862 12.2407 36.8379 8.4931 32.1221 8.00476L32.1224 8.00508Z",
    fill: "#767881"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1021 18.0002C36.68 18.0002 37.1573 17.5276 37.0584 16.9577C36.6235 14.4409 34.637 12.4549 32.1182 12.0184C31.5482 11.9195 31.0771 12.3983 31.0771 12.9761C31.0771 13.5539 31.553 14.0092 32.112 14.1583C33.4766 14.5257 34.5522 15.6012 34.9181 16.9656C35.0689 17.5229 35.5227 18.0002 36.1021 18.0002H36.1021Z",
    fill: "#767881"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_86_56220",
    x: -14,
    y: -18,
    width: 1525,
    height: 96,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.307813 0 0 0 0 0.326577 0 0 0 0 0.375 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_86_56220"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_86_56220",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_86_56220"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1050,
    fill: "white",
    transform: "translate(-43 -98)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalDevices);
export default __webpack_public_path__ + "static/media/total-devices.ce1ddb930bd8e071f8ebebeed8adeed8.svg";
export { ForwardRef as ReactComponent };